var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgStar00(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 117,
    viewBox: "0 0 120 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_250_438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7475 19.664C57.2768 15.9735 62.7232 15.9735 65.2525 19.664L76.3535 35.8617C77.1815 37.0698 78.4006 37.9556 79.8055 38.3697L98.6408 43.9221C102.932 45.1871 104.615 50.367 101.887 53.9129L89.9125 69.4759C89.0194 70.6367 88.5537 72.0699 88.594 73.534L89.1338 93.1632C89.2568 97.6356 84.8506 100.837 80.6351 99.3379L62.1335 92.7587C60.7535 92.2679 59.2465 92.2679 57.8665 92.7587L39.3649 99.3379C35.1494 100.837 30.7432 97.6356 30.8662 93.1632L31.4061 73.534C31.4463 72.0699 30.9806 70.6367 30.0875 69.4759L18.113 53.9129C15.3847 50.367 17.0677 45.1871 21.3592 43.9221L40.1945 38.3697C41.5994 37.9556 42.8185 37.0698 43.6465 35.8617L54.7475 19.664Z",
    fill: "#FFD402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4545 16.7842C64.9018 10.1413 55.0982 10.1413 50.5455 16.7842L39.4445 32.9819C39.2789 33.2235 39.0351 33.4007 38.7541 33.4835L19.9188 39.0358C12.1942 41.3129 9.1647 50.6366 14.0756 57.0193L26.0502 72.5823C26.2288 72.8145 26.3219 73.1011 26.3139 73.3939L25.774 93.0232C25.5526 101.073 33.4838 106.836 41.0716 104.138L59.5733 97.5583C59.8493 97.4602 60.1507 97.4602 60.4267 97.5583L78.9284 104.138C86.5162 106.836 94.4474 101.073 94.226 93.0232L93.6861 73.3939C93.6781 73.1011 93.7712 72.8145 93.9498 72.5823L105.924 57.0193C110.835 50.6366 107.806 41.3129 100.081 39.0358L81.2459 33.4835C80.9649 33.4007 80.7211 33.2235 80.5555 32.9819L69.4545 16.7842Z",
    stroke: "white",
    strokeWidth: 10.1882
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_250_438",
    x: 0.226607,
    y: 0.340254,
    width: 119.547,
    height: 115.937,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.18382
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_250_438"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_250_438",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgStar00);
export default __webpack_public_path__ + "static/media/img_star_00.4340f0fd22b4c05f57dcf9816f651738.svg";
export { ForwardRef as ReactComponent };